import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function get () {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/me?include=roles,permissions`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function update (signature) {
    const payload = jsona.serialize({
        stuff: signature,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };
    console.log('Yahaya');
    console.log(signature);
    return axios.patch(`${url}/me/signature`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

export default {
    get,
    update,
};

